export default "__VITE_ASSET__CryW1t2Z__"